import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { snackbarErrorDefault } from '../../../../../../snackbarsStack';
import { getMessages } from '../../../../../../../../store/constants';

export const onShowSnackbar = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(snackbarErrorDefault({
            id: 'SNACKBAR_ID_CARD_COLOR_ERROR',
            text: getMessages().getText('card_form_edit_color_error'),
        }));
    };
    return action;
};
